import "./file.css";
import React, { useState } from "react";

export default function FileOperations({ setSelectedFile, setFileContent }) {
    const handleOpenFile = (event) => {
      const file = event.target.files[0];
      if (file) {
        setSelectedFile(file);
        if (file.type.includes("text")) {
          const reader = new FileReader();
          reader.onload = (e) => setFileContent(e.target.result);
          reader.readAsText(file);
        }
      }
    };
  
    return (
      <div>
        <input type="file" onChange={handleOpenFile} />
      </div>
    );
  }